module.exports = __webpack_public_path__ + "static/media/logo_mini_siv.3d4e1e91.png";